import { useMemo } from 'react';
import { DateTime } from 'luxon';

export const useDays = ({ numberOfDays }: { numberOfDays: number }) =>
  useMemo(
    () =>
      Array(numberOfDays)
        .fill(undefined)
        .map((_, index) =>
          DateTime.now()
            .setZone(process.env.NEXT_PUBLIC_SERVER_TIMEZONE)
            .plus({ days: index }),
        ),
    [numberOfDays],
  );
